export default (timestamp, getDate = true, getTime = true) => {
    if (isNaN(new Date(timestamp).getTime())) {
        return false
    }
    const date = new Date(timestamp)
    const hourFormat = date.getHours() > 12 ? "PM" : "AM"
    let hours = date.getHours()
    let minutes = date.getMinutes()
    hours = hours % 12
    hours = hours ? hours : 12 // the hour '0' should be '12'
    hours = hours < 12 ? '0' + hours : hours
    minutes = minutes < 10 ? '0' + minutes : minutes
    const d = `${date.toLocaleString('default', { month: 'short' })} ${date.getDate()}`
    const t = `${hours}:${minutes} ${hourFormat}`
    if (getDate && getTime) {
        return d + ", " + t
    }
    if (getDate) {
        return d
    }
    if (getTime) {
        return t
    }
}